import { FC } from "react";
import cx from "classnames";

type FormGroupProps = {
  label?: string;
  className?: string;
  hint?: string;
  error?: string;
};

export const FormGroup: FC<FormGroupProps> = ({
  children,
  label,
  className,
  hint,
  error,
}) => {
  return (
    <label className={cx("mb-6 block", className)}>
      {!!label && <div className="mb-2 font-bold">{label}</div>}
      {children}
      {!!hint && <div className="mt-2 text-sm text-gray-500">{hint}</div>}
      {!!error && <div className="mt-2 text-sm text-red-600">{error}</div>}
    </label>
  );
};
